// extracted by mini-css-extract-plugin
export default {"header":"style_header__iHRxt","side":"style_side__87-Xz"};